function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { extractNonLinearAdsFromVmap } from '../parsers/vmap-non-linear-ad-extractor';
import { PixelFetch } from '../pixel-fetch';
import { mapNonLinearAdDataToEvent } from '../non-linear-adverts/map-non-linear-ad-data-to-event';
// NOTE: The logic of how and when to raise events
// is a bit convoluted. For detail, see the flow chart here:
// https://wiki.at.sky/display/CC/Peacock+Ads
export var PauseAdvertDispatcher = /*#__PURE__*/ function() {
    "use strict";
    function PauseAdvertDispatcher(sessionController) {
        var _this = this;
        var pixelFetch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new PixelFetch(self);
        _class_call_check(this, PauseAdvertDispatcher);
        _define_property(this, "sessionController", void 0);
        _define_property(this, "pixelFetch", void 0);
        _define_property(this, "ads", void 0);
        _define_property(this, "isLinearAdShowing", void 0);
        _define_property(this, "isPrerollComplete", void 0);
        this.sessionController = sessionController;
        this.pixelFetch = pixelFetch;
        this.ads = [];
        this.isLinearAdShowing = false;
        this.isPrerollComplete = false;
        sessionController.onAdBreakStarted(function() {
            return _this.isLinearAdShowing = true;
        });
        sessionController.onAdBreakFinished(function() {
            return _this.isLinearAdShowing = false;
        });
        sessionController.onPlaybackTimelineUpdated(function(param) {
            var position = param.position;
            if (position > 0) {
                // TODO handle linear prerolls
                _this.isPrerollComplete = true;
            }
        });
    }
    _create_class(PauseAdvertDispatcher, [
        {
            key: "addAdEvents",
            value: function addAdEvents(adEvents) {
                this.ads = this.ads.concat(adEvents);
            }
        },
        {
            key: "addAdEventsFromAdData",
            value: function addAdEventsFromAdData(ads) {
                var _this = this;
                this.addAdEvents(ads.map(function(ad) {
                    return mapNonLinearAdDataToEvent(ad, _this.pixelFetch);
                }));
            }
        },
        {
            key: "addAdEventsFromVmap",
            value: function addAdEventsFromVmap(vmapDocument) {
                var ads = extractNonLinearAdsFromVmap(vmapDocument);
                this.addAdEventsFromAdData(ads);
            }
        },
        {
            key: "registerUserPause",
            value: function registerUserPause() {
                if (!this.ads.length) {
                    return;
                }
                if (!this.isPrerollComplete) {
                    return;
                }
                if (this.isLinearAdShowing) {
                    return;
                }
                this.sessionController.notifyPauseAd(this.makeNonLinearAdEvent());
            }
        },
        {
            key: "makeNonLinearAdEvent",
            value: function makeNonLinearAdEvent() {
                var _this = this;
                // this logic ensures that if consume is not called,
                // the same Pause ad is reused the next time an event is raised.
                return {
                    consume: function() {
                        var adEvent = _this.ads.shift();
                        return adEvent === null || adEvent === void 0 ? void 0 : adEvent.consume();
                    }
                };
            }
        }
    ]);
    return PauseAdvertDispatcher;
}();

//# sourceMappingURL=pause-advert-dispatcher.js.map